import React from "react";
import Nomenklatury from "../../components/spravochniki/nomenklatura/Nomenklatury"

function NomenklaturyPage(props) {
  return (
    <>
      <Nomenklatury />
    </>
  );
}

export default NomenklaturyPage;
